import { render, staticRenderFns } from "./ReportLabels.vue?vue&type=template&id=6b19c103"
import script from "./ReportLabels.vue?vue&type=script&lang=js"
export * from "./ReportLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports